<template>
  <data-table
    :data="tabelData"
    :pagination="true"
    :table-column="tableColumn"
    @changeBypagination="tableHandle"
    @buttonClick="buttonClick"
  />
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types from '@/config';

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  props: {
    courseId: {
      type: Number,
    },
  },
  data() {
    return {
      tabelData: {},
      searchForm: {
        courseId: this.courseId,
        pageIndex: 1,
        pageSize: 10,

      },
      tableColumn: [
        {
          key: 'userRealName',
          label: '学员名称',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'userWechatNickName',
          label: '微信昵称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'commentContent',
          label: '评价内容',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'commentLevel',
          label: '星级评价',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'isShow',
          label: '状态',
          width: 'auto',
          dataType: 'component',
          renderProps: { [types.COURSE_COMMENT_ENABLE]: '显示', [types.COURSE_COMMENT_DISABLE]: '隐藏', successKey: types.COURSE_COMMENT_ENABLE },
          render: () => 'status',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '60px',
          dataType: 'component',
          renderProps: [
            {
              text: '屏蔽', renderKey: types.COURSE_COMMENT_ENABLE, renderProp: 'isShow', type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '显示', renderKey: types.COURSE_COMMENT_DISABLE, renderProp: 'isShow', type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  watch: {
    courseId() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 切换下拉 清除选项的值
    clearSearchValue() {
      this.searchForm.courseName = '';
      this.searchForm.mainTeacherUserRealName = '';
    },
    // 获取列表
    async getList() {
      const result = await axClient.course.pageComment(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList();
    },
    // 显示隐藏 评论
    confirmDialog(item) {
      this.$confirm('确定显示/隐藏该评论？', '显示/隐藏评论', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, isShow } = item;
        if (isShow === types.COURSE_COMMENT_ENABLE) {
          const data = await axClient.course.hideComment({ id });
          if (data) {
            this.$message.success('隐藏成功');
            this.getList();
          }
        } else {
          const data = await axClient.course.showComment({ id });
          if (data) {
            this.$message.success('显示成功');
            this.getList();
          }
        }
      });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .header {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    .l {
      display: flex;
      align-items: center;
      .label {
        font-weight: 500;
        font-size: 14px;
        margin-right: 12px;
        min-width: 50px;
      }
      .el-select {
        margin-right: 15px;
        flex: 1;
        ::v-deep input {
          max-width: 120px;
        }
      }
    }
    .r {
      display: flex;
      align-items: center;
      .input-select {
        width: 150px;
        ::v-deep .el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
        & + .el-input {
          ::v-deep input {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-left: 0;
          }
        }
      }
      & > .el-button {
        flex: 1;
        margin-left: 15px;
        min-width: auto;
      }
    }
  }
}
</style>
